<template>
  <div class="container login-form">
    <div class="title">{{ $t("login.login_title") }}</div>
    <el-form :model="form" :rules="rules" ref="form">
      <el-form-item style="position: relative" prop="userName">
        <el-input
          class="login-input has-prepend"
          :placeholder="$t('login.username_placeholder')"
          @blur="getCodeInfo"
          tabindex="1"
          v-model="form.userName"
        >
          <i slot="prefix" class="prepend h-icon-user"></i>
        </el-input>
      </el-form-item>
      <el-form-item style="position: relative" prop="password">
        <el-input
          type="password"
          :placeholder="$t('login.password_placeholder')"
          tabindex="2"
          v-model="form.password"
          class="login-input has-prepend"
          @keydown.native="handleCapsLock($event, 'showCapsFirst')"
          @keyup.native="form.password = form.password.replace(/\s+/g, '')"
          @keyup.enter.native="login"
        >
          <i
            slot="prefix"
            class="prepend"
            :class="{'h-icon-lock':!showCapsFirst,'h-icon-capital':showCapsFirst}"
          ></i>
        </el-input>
      </el-form-item>
      <el-form-item class="h-form-item">
        <el-checkbox v-model="remember" tabindex="-1">
          {{
          $t("login.remember_user_name")
          }}
        </el-checkbox>
      </el-form-item>
      <el-form-item prop="verifyCode" v-show="verifyCodeImg !== ''" class="h-form-item">
        <el-input
          :placeholder="$t('login.verifycode_placeholder')"
          v-model="form.verifyCode"
          class="login-input verify-code-input"
          tabindex="3"
          @keyup.enter.native="login"
        >
          <template slot="append">
            <div class="code-img" :style="verifyCodeStyle"></div>
            <span class="change-btn" @click="getCodeInfo">
              {{
              $t("login.change_text")
              }}
            </span>
          </template>
        </el-input>
      </el-form-item>

      <el-form-item>
        <el-button
          type="primary"
          style="height: 48px;width: 100%;border-radius:4px"
          @click="login"
          :loading="isLoading"
          :max-width="500"
          :disabled="loginDisabled"
          class="login-btn"
        >{{ $t("login.login_btn") }}</el-button>
      </el-form-item>
    </el-form>
    <div class="m-certificate">
      <i class="h-icon-angles_right_sm brand-color"></i>
      {{ $t("login.SSL_des") }}
      <a
        href="/nginxService/v1/download/InstallRootCert.exe "
        class="brand-color"
      >
        {{
        $t("login.download_now")
        }}
      </a>
    </div>
    <div class="m-overdue-cover" v-if="!LicenseMsg.allowLogin">
      <!--  -->
      <div class="m-overdue-icon"></div>
      <div class="m-overdue-txt">
        {{
        LicenseMsg.noLicense
        ? $t("login.noLicense_des")
        : $t("login.authorized_expiration_date_des")
        }}
        <br />
        {{ $t("login.contact_manager") }}
      </div>
    </div>
  </div>
</template>

<script>
import Api from "api/api";
import { encrypt } from "@hui-pro/utils";
import { ErrorHandleMixin } from "utils/mixin";
export default {
  name: "login-form",
  props: {
    serviceUrl: {
      type: String,
      default: () => {
        return "";
      }
    },
    language: {
      type: String,
      default: () => {
        return "";
      }
    },
    loginDisabled: {
      type: Boolean,
      default: () => {
        return false;
      }
    },
    LicenseMsg: {
      type: Object,
      default: () => {
        return {};
      }
    },
    panelColor: {
      type: String,
      default: "#fff"
    }
  },
  data() {
    return {
      form: {
        userName: "",
        password: "",
        verifyCode: "",
        verifyCodeId: ""
      },
      verifyCodeImg: "",
      remember: false,
      isLoading: false,
      showCapsFirst: false,
      rules: {
        userName: {
          validator: (rule, value, callback) => {
            if (value.trim() === "") {
              callback(new Error(this.$t("login.username_error")));
            }
            callback();
          },
          trigger: "blur"
        },
        password: {
          validator: (rule, value, callback) => {
            if (value.trim() === "") {
              callback(new Error(this.$t("login.password_error")));
            }
            callback();
          },
          trigger: "blur"
        },
        verifyCode: {
          validator: (rule, value, callback) => {
            if (value.trim() === "" && this.verifyCodeImg !== "") {
              callback(new Error(this.$t("login.verify_error")));
            }
            callback();
          },
          trigger: "blur"
        }
      }
    };
  },
  computed: {
    verifyCodeStyle() {
      return {
        background: `url(data:image/png;base64,${this.verifyCodeImg}) no-repeat center`
      };
    },
    panelStyle() {
      return {
        background: `${this.panelColor ? this.panelColor : "#000"}`
      };
    }
  },
  watch: {
    remember() {
      if (this.remember) {
        this.setCookie("remember", "yes");
        this.setCookie("user-name", this.form.userName);
      } else {
        this.delCookie("user-name");
        this.setCookie("remember", "no");
      }
    },
    "form.userName"() {
      if (this.remember) {
        this.setCookie("user-name", this.form.userName);
      }
    },
    language() {
      this.initValidate();
    }
  },
  mounted() {
    this.form.userName = this.getCookie("user-name") || "";
    this.remember = this.getCookie("remember") === "yes";
    if (this.form.userName) {
      this.getCodeInfo();
    }
  },
  methods: {
    initValidate() {
      this.$refs.form.resetValidates();
    },
    handleCapsLock(evt, key) {
      if (evt.getModifierState) {
        this[key] = evt.getModifierState("CapsLock");
      }
    },
    _doLogin(publicKey) {
      let params = {
        serviceUrl: this.serviceUrl,
        language: this.language,
        publicKey: publicKey,
        ...this.form
      };
      params.password = encrypt(publicKey, params.password);
      Api.login
        .submit(params)
        .then(res => {
          if (top.window !== window) {
            // 如果是mini-login登录那么就是重定向父页面href
            top.window.location.href = res.data;
          }
          window.location.href = res.data;
          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
          this.getCodeInfo();
        });
    },
    getCodeInfo() {
      Api.login
        .verifyCode({
          id: this.form.userName,
          width: 86,
          height: 38,
          language: this.$storage.get("portal_language")
        })
        .then(res => {
          this.verifyCodeImg = res.data ? res.data.base64Image : "";
          this.form.verifyCode = "";
          this.form.verifyCodeId = res.data ? res.data.verifyCodeId : "";
        });
    },
    login() {
      if (this.loginDisabled) return;
      if (this.form.password.length > 20) {
        this.$message.error(this.$t("login.account_pwd_error"));
        return false;
      }
      this.$refs.form.validate(valid => {
        if (valid) {
          this.isLoading = true;
          Api.common
            .getPublicKey()
            .then(res => {
              this._doLogin(res.data.publicKey);
            })
            .catch(() => {
              this.isLoading = false;
            });
        }
      });
    },
    setCookie(name, value) {
      let Days = 30;
      let exp = new Date();
      exp.setTime(exp.getTime() + Days * 24 * 60 * 60 * 30);
      document.cookie = `${name}=${escape(value)};expires=${exp.toGMTString()}`;
    },
    getCookie(name) {
      let reg = new RegExp(`(^| )${name}=([^;]*)(;|$)`);
      let arr = document.cookie.match(reg);
      if (arr) {
        return unescape(arr[2]);
      } else {
        return null;
      }
    },
    delCookie(name) {
      let exp = new Date();
      exp.setTime(exp.getTime() - 1);
      let cval = this.getCookie(name);
      if (cval != null) {
        document.cookie = `${name}=${cval};expires=${exp.toGMTString()}`;
      }
    }
  },
  mixins: [ErrorHandleMixin]
};
</script>

<style scoped lang="less" rel="stylesheet/less">
.login-form.container {
  position: relative;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  // padding: 40px;
  // border-radius: 3px;
  background: transparent !important;
  // color: rgba(255, 255, 255, 0.7) !important;
  // /deep/ .el-input__inner{
  //   text-indent: 24px;
  // }
  /deep/.el-input__inner {
    background: rgba(0, 0, 0, 0.4) !important ;
    border: 1px solid rgba(255, 255, 255, 0.2);
    border-radius: 4px;
    color: rgba(255, 255, 255, 0.6);
    &:hover{
      border: 1px solid rgba(255, 255, 255, 0.7);
      color: rgba(255, 255, 255, 0.7);

    }
    &:focus{
      border: 1px solid rgba(255, 255, 255, 0.7);
      color: #fff;
    }
  }
  /deep/.login-input{
    &:focus{
      .el-input__prefix{
        color: #fff;
      }
    }
  }
  /deep/.el-input__prefix {
    top: 8px;
  }
 
  /deep/.el-checkbox__inner {
    background: rgba(0, 0, 0, 0.4) !important ;
    border: 1px solid rgba(255, 255, 255, 0.3) !important;
    &:hover{
      border: 1px solid rgba(255, 255, 255, 0.7) !important;
    }
  }
  /deep/.el-checkbox__label {
    color: rgba(255, 255, 255, 0.7);
    outline: none;
  }
  /deep/.el-checkbox{
    outline: none;
  }
  .m-overdue-cover {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    z-index: 2;
    background: rgba(255, 255, 255, 0.95);
    .m-overdue-icon {
      width: 72px;
      height: 72px;
      margin: 100px auto 8px;
      background-image: url("../../assets/images/error_control.png");
      background-size: contain;
      background-position: center;
      background-repeat: no-repeat;
    }
    .m-overdue-txt {
      text-align: center;
      font-size: 12px;
      color: rgba(0, 0, 0, 0.4);
      line-height: 20px;
    }
  }
  .title {
    margin: 0 0 40px;
    font-size: 18px;
    // color: rgba(0, 0, 0, 0.9);
    font-family: MicrosoftYaHeiUI;
    font-size: 44px;
    color: #33ADFF;
    letter-spacing: 0;
  }
  .prepend {
    font-size: 24px;
    &.h-icon-capital {
      color: #5d5d5d;
    }
  }
  .code-img {
    width: 86px;
    height: 38px;
    display: inline-block;
    vertical-align: middle;
  }
  .change-btn {
    width: 48px;
    height: 38px;
    line-height: 38px;
    cursor: pointer;
    display: inline-block;
    vertical-align: middle;
    text-align: center;
  }
  .verify-code-input {
    vertical-align: top;
  }
  .m-certificate {
    position: relative;
    width: 100%;
    font-size: 14px;
    line-height: 18px;
    text-indent: 18px;
    // color: rgba(0, 0, 0, 0.4);
    color: rgba(255, 255, 255, 0.7);
    i {
      display: block;
      font-size: 24px;
      position: absolute;
      left: -22px;
      top: -3px;
      color: rgba(255, 255, 255, 0.7) !important;
    }
    a {
      text-decoration: underline;
    }
  }
  /deep/ .el-form-item {
    margin-bottom: 24px;
  }
}
</style>
